import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4859f07a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tb_head" }
const _hoisted_2 = { class: "tb_item" }
const _hoisted_3 = { class: "title" }

import { withDefaults } from 'vue';
interface Props {
  title: string;
  icon?: string;
}

const __default__ = { name: 'TableHead' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: { default: '' },
    icon: { default: '' }
  },
  setup(__props: any) {

const props = __props as { title: string, icon: string };



return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.icon)
        ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            "icon-class": props.icon
          }, null, 8, ["icon-class"]))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_3, _toDisplayString(props.title), 1)
    ])
  ]))
}
}

})